import React from "react";
import { useTranslation } from 'react-i18next';

import IColumn from "../../../yoello-lib/modules/components/lists/interfaces/IColumn";

export function OrderListHeaders({
    label,
    onEntryClick,
    componentTransform,
    textAlign
}: IColumn<string>) {
    const { t } = useTranslation();

    return <div>
        <span style={{textAlign: textAlign || "center"}} key={`label-${label}`}>{t(label)}</span>
    </div>;
}